<template>
  <div class="filter">
    <div class="section section--filter">
      <div class="wrapper">
        <div class="container">

          <form action="#"
                class="form form--filter form--filter-vehicles large-width"
                @submit="formSubmitHandler">

            <div v-if="isContentReady">
              <div class="filters">
                <div class="field-group field-group--select">
                  <label class="label label--select"
                         for="selectedBrand">{{ lexicon.brand }}</label>

                  <template v-if="isMobileAndTouch">
                    <select class="select"
                            :class="[{'select--dark': selectedBrand !== '*'}]"
                            v-model="selectedBrand"
                            name="selectedBrand"
                            id="selectedBrand">
                      <option v-for="item in brands" :value="item.term_id">{{ item.name }}</option>
                    </select>
                  </template>

                  <template v-else>
                    <multiselect v-if="brands && brands.length > 0"
                                 v-model="selectedBrandObject"
                                 :options="brands"
                                 id="selectedBrand"
                                 class="multiselect--small multiselect--regular"
                                 :class="[{'select--dark': selectedBrand !== '*'}]"
                                 label="name"
                                 :placeholder="lexicon.all"
                                 track-by="term_id">
                      <template slot="singleLabel" slot-scope="{ option }">{{ option.name }}</template>
                    </multiselect>

                  </template>
                </div>

                <div class="field-group field-group--select">
                  <label class="label label--select"
                         for="selectedModel">{{ lexicon.model }}</label>
                  <template v-if="isMobileAndTouch">
                    <select class="select"
                            :class="[{'select--dark': selectedModel !== '*'}]"
                            v-model="selectedModel"
                            name="selectedModel"
                            id="selectedModel">
                      <option v-for="item in availableModels" :value="item.id">{{ item.model }}</option>
                    </select>
                  </template>
                  <template v-else>
                    <multiselect v-if="availableModels && availableModels.length > 0"
                                 v-model="selectedModelObject"
                                 :options="availableModels"
                                 id="selectedModel"
                                 class="multiselect--small multiselect--regular"
                                 :class="[{'select--dark': selectedModel !== '*'}]"
                                 label="model"
                                 :placeholder="lexicon.all"
                                 track-by="id">
                      <template slot="singleLabel" slot-scope="{ option }">{{ option.model }}</template>
                    </multiselect>
                  </template>
                </div>

                <div class="field-group field-group--select">
                  <label class="label label--select"
                         for="selectedType">{{ lexicon.vehicle_type }}</label>
                  <template v-if="isMobileAndTouch">
                    <select class="select"
                            :class="[{'select--dark': selectedType !== '*'}]"
                            v-model="selectedType"
                            name="selectedType"
                            id="selectedType">
                      <option v-for="item in availableTypes" :value="item.term_id">{{ item.name }}</option>
                    </select>
                  </template>
                  <template v-else>
                    <multiselect v-if="availableTypes && availableTypes.length > 0"
                                 v-model="selectedTypeObject"
                                 :options="availableTypes"
                                 id="selectedType"
                                 class="multiselect--small multiselect--regular"
                                 :class="[{'select--dark': selectedType !== '*'}]"
                                 label="name"
                                 :placeholder="lexicon.all"
                                 track-by="term_id">
                      <template slot="singleLabel" slot-scope="{ option }">{{ option.name }}</template>
                    </multiselect>
                  </template>
                </div>

                <div class="field-group field-group--select">
                  <label class="label label--select"
                         for="selectedBranch">{{ lexicon.location }}</label>
                  <template v-if="isMobileAndTouch">
                    <select class="select"
                            :class="[{'select--dark': selectedBranch !== '*'}]"
                            v-model="selectedBranch"
                            name="selectedBranch"
                            id="selectedBranch">
                      <option v-for="item in availableBranches" :value="item.term_id">{{ item.name }}</option>
                    </select>
                  </template>
                  <template v-else>
                    <multiselect v-if="availableBranches && availableBranches.length > 0"
                                 v-model="selectedBranchObject"
                                 :options="availableBranches"
                                 id="selectedBranch"
                                 class="multiselect--small multiselect--regular"
                                 :class="[{'select--dark': selectedBranch !== '*'}]"
                                 label="name"
                                 :placeholder="lexicon.all"
                                 track-by="term_id">
                      <template slot="singleLabel" slot-scope="{ option }">{{ option.name }}</template>
                    </multiselect>
                  </template>
                </div>

                <div class="field-group field-group--select">
                  <label class="label label--select"
                         for="selectedFuelType">{{ lexicon.fuel }}</label>
                  <template v-if="isMobileAndTouch">
                    <select class="select"
                            :class="[{'select--dark': selectedFuelType !== '*'}]"
                            v-model="selectedFuelType"
                            name="selectedFuelType"
                            id="selectedFuelType">
                      <option v-for="item in availableFuelTypes" :value="item.slug">{{ item.name }}</option>
                    </select>
                  </template>
                  <template v-else>

                    <multiselect v-if="availableFuelTypes && availableFuelTypes.length > 0"
                                 v-model="selectedFuelTypeObject"
                                 :options="availableFuelTypes"
                                 id="selectedFuelType"
                                 class="multiselect--small multiselect--regular"
                                 :class="[{'select--dark': selectedFuelType !== '*'}]"
                                 label="name"
                                 :placeholder="lexicon.all"
                                 track-by="slug">
                      <template slot="singleLabel" slot-scope="{ option }">{{ option.name }}</template>
                    </multiselect>
                  </template>
                </div>
              </div>


              <div class="field-group field-group--range"
                   v-if="selectedModel === '*' && this.minWeight !== this.maxWeight">
                <label class="label label--select" for="weightInput">{{ lexicon.total_weight }}</label>

                <span class="input-range__value">{{ `${lexicon.from} ${parseFloat(selectedRangeWeight[0]/1000).toFixed(1).replace('.0', '')} ${lexicon.until.toLowerCase()} ${convertWeightToTons(selectedRangeWeight[1])}`}}</span>

                <vue-slider
                    :min="minWeight"
                    :max="maxWeight"
                    :height="11"
                    step="100"
                    v-model="selectedRangeWeight"
                    :tooltip-formatter="weightFormatter"
                />


<!--                <input type="range"
                       v-model="selectedWeight"
                       id="weightInput"
                       name="weightInput"
                       :min="minWeight"
                       :style="{background: `linear-gradient(to right, rgba(41,153,88,1), rgba(0,153,153,1) ${selectedWeightToPercent/2}%, rgba(13,146,205,1) ${selectedWeightToPercent}%, #F5F5F5 ${selectedWeightToPercent}%, #F5F5F5 100%)`}"
                       step="100"
                       :max="maxWeight">-->

                <span class="input-range__min">{{ convertWeightToTons(minWeight, true) }}</span>
                <span class="input-range__max">{{ convertWeightToTons(maxWeight, true) }}</span>




              </div>

              <button class="action action--underline action--reset"
                      @click="resetFilters">
                <span class="action__text">{{ lexicon.filter_reset }}</span>
              </button>
            </div>
            <template v-else>
              <content-loader
                :height="219"
                :width="1050"
                :speed="2"
                primaryColor="#f3f3f3"
                secondaryColor="#ecebeb"
              >
              </content-loader>
            </template>
          </form>
        </div>
      </div>
    </div>

    <div class="section section--results">
      <div class="wrapper">
        <div class="container">
          <div v-if="isContentReady"
               class="row row--grid">
            <a v-for="item in selectionPaginated"
               class="col-sm-12 col-md-12 col-lg-6 teaser"
               :href="item.link">
              <figure v-if="item.feature">
                <picture>
                  <source  v-if="isWebpEnable" :srcset="item.feature[0]">
                  <img :src="isWebpEnable ? item.feature[0].replace('.jpg', '.webp') : item.feature[0]"
                       :width="item.feature[1]"
                       :height="item.feature[2]"
                       loading="lazy"
                       :alt="item.post_title">
                </picture>
              </figure>

              <div class="teaser__content">
                <p class="title--small teaser__suptitle">{{ item.types[0].name }}</p>
                <h3 class="teaser__title font-weight-bold"><span v-if="item.brand[0]">{{ item.brand[0].name }}</span>
                  {{ item.model }}</h3>
                <p
                  v-if="item.price_from"
                  class="teaser__price">{{ lexicon.from }}
                  <span v-html="convertToCurrency(item.price_from)"></span>
                </p>

                <dl class="teaser__descriptions">
                  <div v-if="item.payload_up_to" class="teaser__descriptions-item">
                    <dt>{{ lexicon.payload_up_to }}</dt>
                    <dd>{{ formatWeight(item.payload_up_to) }} kg</dd>
                  </div>
                  <div v-if="item.towable_load_up_to" class="teaser__descriptions-item">
                    <dt>{{ lexicon.towable_load_up_to }}</dt>
                    <dd>{{ formatWeight(item.towable_load_up_to) }} kg</dd>
                  </div>
                  <div v-if="item.seats" class="teaser__descriptions-item">
                    <dt>{{ lexicon.seats }}</dt>
                    <dd>{{ `${item.seats_minimum ? `${item.seats_minimum}-` : ''}${item.seats}` }}</dd>
                  </div>
                </dl>
              </div>
            </a>
          </div>

          <div
            v-else
            class="row row--grid">
            <content-loader
              class="col col-sm-12 col-md-12 col-lg-6 teaser teaser--loader"
              v-for="i in 10"
              :height="775"
              :width="761"
              :speed="2"
              primaryColor="#f3f3f3"
              secondaryColor="#ecebeb"
              :key="i"
            ></content-loader>
          </div>

          <div v-if="selection.length > this.selectionPaginated.length">
            <div class="action__container action__container--center">
              <button class="action action--button"
                      @click="showMore">
                <span class="action__text">{{ lexicon.show_more }}</span>
              </button>
            </div>
          </div>

          <div class="row row--grid" v-if="selectionPaginated && selectionPaginated.length === 0">
            <div class="col col-sm-12 col-md-12 offset-lg-2 col-lg-8">
              <div v-html="lexicon.no_result" class="body"></div>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import VMixins from '../VMixins/VMixins.vue';
import {getPosts, getTerms, getLexicon} from "../rest-service/rest-service";
import {isWebP} from '../utils/isWebP';
import VueSlider from 'vue-slider-component'

export default {
  name: "VVehicles",
  mixins: [VMixins],
  props: {
    preselectedBrand: {
      type: String,
      default: '*'
    }
  },
  data() {
    return {
      vehicles: [],
      brands: [],
      models: [],
      types: [],
      locations: [],
      branches: [],
      page: 1,
      posts_per_page: 10,
      selectedBrand: '*',
      selectedModel: '*',
      selectedType: '*',
      selectedFuelType: '*',
      //selectedLocation: '*',
      selectedBranch: '*',

      isWebpEnable: true,

      selectedBrandObject: null,
      selectedModelObject: null,
      selectedTypeObject: null,
      selectedFuelTypeObject: null,
      //selectedLocationObject: null,
      selectedBranchObject: null,
      selectedRangeWeight: [0, 100],
      selectedWeight: 0,
      minWeight: 0,
      maxWeight: 0,
      lexicon: {},
      isContentReady: false,


      weightFormatter: v => `${(parseFloat(v) / 1000).toFixed(1)}`,

    }
  },


  mounted() {
  },

  computed: {

    selection() {
      return this.availableModels.filter(item => {
        return item.id !== '*' &&
          this.getModelsByBrand(item, this.selectedBrand) &&
          this.getModelsByModel(item, this.selectedModel) &&
          this.getModelsByType(item, this.selectedType) &&
          this.getModelsByBranch(item, this.selectedBranch) &&
          this.getModelsByWeight(item, this.selectedRangeWeight) &&
          this.getModelsByFuelType(item, this.selectedFuelType)
      })
    },

    selectionPaginated() {
      return this.selection.slice(0, this.posts_per_page * this.page)
    },

    selectedWeightToPercent() {
      return `${(this.selectedWeight - this.minWeight) * 100 / (this.maxWeight - this.minWeight)}`
      //return `${(this.selectedRangeWeight[1] - this.minWeight) * 100 / (this.maxWeight - this.minWeight)}`
    },

    availableModels() {
      let temp = []
      if (this.selectedBrand === '*') {
        temp = this.models
      } else {
        temp = this.models.filter(item => {
          //return item.brand.some(brandItem => brandItem.term_id === this.selectedBrand)
          return item.brand === this.selectedBrand;
        })

        if (!temp.find(item => item.id === this.selectedModel)) {
          this.selectedModel = '*'
          this.selectedModelObject = {'model': this.lexicon.all, id: '*'}
        }
      }

      temp = temp.map(item => {
        item.weight = parseFloat(item.weight);
        return item
      });

      this.maxWeight = temp.length > 0 ? Math.ceil((temp.reduce((max, p) => p.weight > max ? p.weight : max, temp[0].weight)) / 1000) * 1000 : 0;
      this.minWeight = temp.length > 0 ? Math.floor((temp.reduce((min, p) => p.weight < min ? p.weight : min, temp[0].weight)) / 1000) * 1000 : 0;

      this.selectedRangeWeight = [this.minWeight, this.maxWeight]

      /*if (this.selectedWeight === 0 || this.selectedWeight > this.maxWeight) {
        setTimeout(() => {
          this.selectedWeight = this.maxWeight
        }, 0)
      } else if (this.selectedWeight < this.minWeight) {
        this.selectedWeight = this.minWeight
      } else {
        //console.log('plus')
        //this.selectedWeight = this.maxWeight
      }*/

      return [{'model': this.lexicon.all, id: '*'}, ...this.sortAlphabetically(temp, 'model')];
    },

    availableTypes() {
      let temp = []
      if (this.selectedBrand === '*' && this.selectedModel === '*') {
        temp = this.types
      } else if (this.selectedModel !== '*') {
        const currentModel = this.availableModels.find(model => model.id === this.selectedModel)
        temp = this.types.filter(item => currentModel.types.some(type => type.term_id === item.term_id))
      } else {
        temp = this.types.filter(item => this.availableModels.some(modelItem => {
          return modelItem.types && modelItem.types.find(type => type.term_id === item.term_id)
        }))
      }

      return [{name: this.lexicon.all, term_id: '*', slug: '*'}, ...this.sortAlphabetically(temp, 'name')]
    },

    /*availableLocations() {
      let temp = []
      if (this.selectedBrand === '*' && this.selectedModel === '*') {
        temp = this.locations
      } else if (this.selectedModel !== '*') {
        const currentModel = this.availableModels.find(model => model.id === this.selectedModel)
        temp = this.locations.filter(item => currentModel.locations.some(location => location.term_id === item.term_id))
      } else {
        temp = this.locations.filter(item => this.availableModels.some(modelItem => {
          return modelItem.locations && modelItem.locations.find(location => location.term_id === item.term_id)
        }))
      }

      if (!temp.find(item => item.term_id === this.selectedLocation)) {
        this.selectedLocation = '*'
      }

      return [{name: this.lexicon.all, term_id: '*', slug: '*'}, ...this.sortAlphabetically(temp, 'name')]
    },*/

    availableBranches() {
      let temp = []
      if (this.selectedBrand === '*' && this.selectedModel === '*') {
        temp = this.branches
      } else if (this.selectedModel !== '*') {
        const currentModel = this.availableModels.find(model => model.id === this.selectedModel)
        temp = this.branches.filter(item => currentModel.branch === item.term_id)
      } else {
        temp = this.branches.filter(item => this.availableModels.some(modelItem => {
          return modelItem.branch && modelItem.branch.find(branch => branch.term_id === item.term_id)
        }))
      }

      if (!temp.find(item => item.term_id === this.selectedBranch)) {
        this.selectedBranch = '*'
        this.selectedBranchObject = {name: this.lexicon.all, term_id: '*', slug: '*'}
      }

      return [{name: this.lexicon.all, term_id: '*', slug: '*'}, ...this.sortAlphabetically(temp, 'name')]
    },


    availableFuelTypes() {
      let temp = this.availableModels.map(item => {
        return  {
          name: item.fuel_type,
          slug: item.fuel_type
        }
      }).filter((value, index, self) => {
        return value.slug && index === self.findIndex((t) => (
            t.slug === value.slug
        ))
          }
      )

      return [{name: this.lexicon.all, slug: '*'}, ...this.sortAlphabetically(temp, 'name')]
    },


  },

  methods: {

    convertWeightToTons(weight, short = false) {
      return `${(weight / 1000).toFixed(1).replace('.0', '')}${short ? 't' : ' ' + this.lexicon.tons}`
    },


    getModelsByBrand(item, brand) {
      if (brand !== '*') {
        //return item.brand.find(brandItem => brandItem.term_id === brand)
        return item.brand === brand
      }

      return true
    },

    getModelsByWeight(item, rangeWeight) {
      if (rangeWeight.length === 2 && this.selectedModel === '*') {
        return item.weight <= rangeWeight[1] && item.weight >= rangeWeight[0]
      }

      return true
    },

    getModelsByFuelType(item, fuelType) {
      if (fuelType !== '*') {
        return item.fuel_type === fuelType
      }

      return true
    },

    getModelsByModel(item, model) {
      if (model !== '*') {
        return item.id === model
      }

      return true
    },

    getModelsByType(item, type) {
      if (type !== '*') {
        return item.types.find(typeItem => typeItem.term_id === type)
      }

      return true
    },

    getModelsByLocation(item, location) {
      if (location !== '*') {
        return item.locations.find(locationItem => locationItem.term_id === location)
      }

      return true
    },

    getModelsByBranch(item, branch) {
      if (branch !== '*') {
        return item.branch.find(branchItem => branchItem.term_id === branch)
      }

      return true
    },

    resetFilters(evt) {
      evt.preventDefault();
      //this.selectedWeight = this.maxWeight;
      this.selectedRangeWeight = [this.minWeight, this.maxWeight]

      this.page = 1;

      this.selectedBrandObject = this.brands[0];
      this.selectedModelObject = this.availableModels[0];
      this.selectedTypeObject = this.availableTypes[0];
      this.selectedBranchObject = this.availableBranches[0];
      this.selectedFuelTypeObject = this.availableFuelTypes[0];

      this.selectedBrand = '*';
      this.selectedBranch = '*';
      this.selectedModel = '*';
      this.selectedType = '*';
      this.selectedFuelType = '*'
    },

    formSubmitHandler(evt) {
      evt.preventDefault();
    },

    showMore() {
      this.page++
    },

    formatWeight(number) {
      return new Intl.NumberFormat('de-CH').format(number)
    }
  },

  created() {
    isWebP().then(hasWebP => {
      this.isWebpEnable = hasWebP
    })
  },

  asyncComputed: {
    getContent() {
      const getOffers = () => {
        return new Promise(resolve => {
          getPosts({
            post_type: 'vehicles',
            post_status: 'publish',
            posts_per_page: -1,
            orderby: 'menu_order',
            order: 'DESC',
            suppress_filters: 0,
            lang: this.lang
          }, (response) => {
            //console.log('vehicles ', response.data)
            resolve(response.data)
          })
        })
      };

      /*const getLocations = () => {
        return new Promise(resolve => {
          getTerms({
            taxonomy: 'team-locations',
            suppress_filters: 0,
            lang: this.lang
          }, (response) => {
            //console.log('locations ', response.data)
            resolve(response.data)
          })
        })
      }*/

      const getBranches = () => {
        return new Promise(resolve => {
          getTerms({
            taxonomy: 'branche',
            suppress_filters: 0,
            lang: this.lang
          }, (response) => {
            //console.log('branches ', response.data)
            resolve(response.data)
          })
        })
      }

      const getTypes = () => {
        return new Promise(resolve => {
          getTerms({
            taxonomy: 'vehicles-types',
            suppress_filters: 0,
            lang: this.lang
          }, (response) => {
            //console.log('types ', response.data)
            resolve(response.data)
          })
        })
      }

      const getBrands = () => {
        return new Promise(resolve => {
          getTerms({
            taxonomy: 'vehicles-brands'
          }, (response) => {
            //console.log('brands ', response.data)
            resolve(response.data)
          })
        })
      }

      const getLexiconContent = () => {
        return new Promise(resolve => {
          getLexicon(this.lang, (response) => {
            resolve(response.data)
          })
        })
      }

      Promise.all([
        getOffers(),
        //getLocations(),
        getTypes(),
        getBrands(),
        getLexiconContent(),
        getBranches()
      ]).then(result => {
        this.models = this.sortAlphabetically(result[0], 'model')
        //this.locations = this.sortAlphabetically(result[1], 'name')
        this.branches = this.sortAlphabetically(result[4], 'name')

        const types = typeof (result[1]) === 'object' ? Object.values(result[1]) : result[1];

        this.types = this.sortAlphabetically(types, 'name')
        this.lexicon = result[3]
        this.brands = [{name: this.lexicon.all, term_id: '*', slug: '*'}, ...this.sortAlphabetically(result[2], 'name')]
        this.selectedBrandObject = {name: this.lexicon.all, term_id: '*', slug: '*'};
        this.selectedTypeObject = {name: this.lexicon.all, term_id: '*', slug: '*'};
        this.selectedModelObject = {model: this.lexicon.all, id: '*', slug: '*'};
        this.selectedBranchObject = {name: this.lexicon.all, term_id: '*', slug: '*'};

        const currentUrl = window.location.href.split('?');

        if (currentUrl.length > 1) {
          const searchParams = new URLSearchParams(currentUrl[1])

          if (searchParams.has("type")) {
            const preSelectedTypeFromUrl = this.types.find(item => item.slug === searchParams.get("type"))
            if (preSelectedTypeFromUrl) {
              this.selectedTypeObject = preSelectedTypeFromUrl
            }
          }

          if (searchParams.has("branch")) {
            const preSelectedBranchFromUrl = this.branches.find(item => item.slug === searchParams.get("branch"))
            if (preSelectedBranchFromUrl) {
              this.selectedBranchObject = preSelectedBranchFromUrl
            }
          }
        }

        if (this.preselectedBrand !== '*') {
          this.selectedBrandObject = this.brands.find(item => item.slug === this.preselectedBrand) || null
        }

        this.isContentReady = true
      });
    }
  },

  components: {
    VueSlider
  },

  watch: {
    selection: {
      immediate: false,
      deep: false,
      handler(newValue) {
        this.page = 1
      }
    },

    selectedBrandObject: {
      immediate: false,
      deep: true,
      handler(newValue) {
        this.selectedBrand = newValue ? newValue.term_id : '*'
      }
    },
    selectedModelObject: {
      immediate: false,
      deep: true,
      handler(newValue) {
        this.selectedModel = newValue ? newValue.id : '*'
      }
    },
    selectedTypeObject: {
      immediate: false,
      deep: true,
      handler(newValue) {
        this.selectedType = newValue ? newValue.term_id : '*'
      }
    },

    selectedFuelTypeObject: {
      immediate: false,
      deep: true,
      handler(newValue) {
        this.selectedFuelType = newValue ? newValue.slug : '*'
      }
    },

    selectedBranchObject: {
      immediate: false,
      deep: true,
      handler(newValue) {
        this.selectedBranch = newValue ? newValue.term_id : '*'
      }
    }
  }
}
</script>
